/** @jsx $jsx */
import { $jsx } from 'framework7';
import { usadosFunciones } from "../js/usadosFunciones";

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on;
  $on('pageInit', function (event, page) {
    var usados = new usadosFunciones();
    var userID = localStorage.getItem('idUser');
    var vehiculoID = page.route.query.id_vehiculo;
    usados.listarImagenes($f7, vehiculoID);
    $('#save-imagen').hide(); // Lanzo el evento click sobre el campo file

    document.getElementById('get-camara').addEventListener('click', function () {
      document.getElementById('fileInput').click();
    });
    document.getElementById('fileInput').addEventListener('change', function () {
      $('#save-imagen').show();
    });
    document.getElementById('save-imagen').addEventListener('click', function () {
      var form = new FormData();
      form.append("file", fileInput.files[0]);
      var url = usados.servicioGlobal + '/datos-vehiculos/saveImagen/' + vehiculoID + '/' + userID;
      $f7.request({
        url: url,
        method: "POST",
        timeout: 0,
        processData: true,
        contentType: "multipart/form-data",
        data: form,
        success: function success(data, status, xhr) {
          var informacion = JSON.parse(data);
          console.log(data);

          if (informacion.Error != 0) {
            $f7.dialog.alert(informacion.Mensaje);
          } else {
            console.log(informacion.IdImagen);
            usados.addImageneSubida($f7, informacion.Nombre_imagen, informacion.IdImagen, vehiculoID);
          }
        },
        statusCode: {
          404: function _(xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    });
    console.log('pageInit');
  }); ///////////////////////

  $on('pageBeforeIn', function (event, page) {
    console.log('pageBeforeIn');
  });
  $on('pageAfterIn', function (event, page) {
    console.log('pageAfterIn');
  });
  $on('pageBeforeRemove', function (event, page) {
    console.log('pageBeforeRemove');
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="about">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Volver</span>
          </a>
        </div>
        <div class="title">IMAGENES</div>
      </div>
    </div>
    <div class="fab fab-extended fab-right-bottom color-green">
      <a href="" id="get-camara">
        <i class="icon f7-icons if-not-md">camera_fill</i>
        <i class="icon material-icons md-only">camera_fill</i>
        <!-- <div class="fab-text popup-open" href="#" data-popup=".popup-about">Agregar</div> -->
        <!-- <div class="fab-text" href="#">Agregar</div> -->
      </a>
    </div>
    <div class="fab fab-extended fab-center-bottom color-blue">
      <a href="#" id="save-imagen">
        <i class="icon f7-icons if-not-md">cloud_upload_fill</i>
        <i class="icon material-icons md-only">cloud_upload_fill</i>
        <div class="fab-text">Guardar</div>
      </a>
    </div>
    
    <div class="page-content">
      <div class="block">
        <!-- <p class="row text-align-right">
          <a class="" href="#"></a>
          <a class="" href="#"></a>
          <a class="button button-fill button-small color-green" href="#" id="save-imagen">Guardar Imagen</a>
        </p> -->

        <input id="fileInput" name="fileInput" type="file" style="display: none;"/>

        <div id="get-imagenes">
        </div>
        
      </div>
    </div>
  </div>
  `
    }
    ;
}

framework7Component.id = '43c67e82d0';
export default framework7Component;